import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconCartPath = _resolveComponent("IconCartPath")!
  const _component_IconBase = _resolveComponent("IconBase")!

  return (_openBlock(), _createBlock(_component_IconBase, {
    width: _ctx.iconSize,
    height: _ctx.iconSize,
    "view-box": "0 0 24 24",
    "icon-color": _ctx.iconColor
  }, {
    default: _withCtx(() => [
      _createVNode(_component_IconCartPath)
    ]),
    _: 1
  }, 8, ["width", "height", "icon-color"]))
}